import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=031a789a&scoped=true&"
import script from "./registerUser.vue?vue&type=script&lang=js&"
export * from "./registerUser.vue?vue&type=script&lang=js&"
import style0 from "./registerUser.vue?vue&type=style&index=0&id=031a789a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a789a",
  null
  
)

export default component.exports